import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  number: 1,
  title: 'Guía para Acompañar a Mamá',
  description: 'Pasos simples para ayudarla a escribir su historia y convertir cada página en un momento especial entre las dos.',
  value: '$12.000'
}, {
  number: 2,
  title: 'Cartas que Mamá Puede Dejar',
  description: 'Plantillas para que ella escriba mensajes y palabras que sus hijos leerán hoy y en el futuro.',
  value: '$15.000'
}, {
  number: 3,
  title: 'Preguntas para la Familia',
  description: 'Preguntas profundas para compartir recuerdos entre generaciones en reuniones familiares.',
  value: '$10.000'
}, {
  number: 4,
  title: 'Plantillas para Fotos y Recuerdos',
  description: 'Hojas imprimibles para conservar imágenes, fechas y momentos importantes de su vida.',
  value: '$15.000'
}];
export function BonusSection() {
  return <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-orange-50 to-white" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-24">
            🎁 4 Bonos Exclusivos — Hoy Completamente Gratis
          </h2>
          <p className="text-xl text-gray-700" data-id="element-25">
            Valor real de los bonos:{' '}
            <span className="line-through" data-id="element-26">$52.000</span>
          </p>
          <p className="text-2xl font-bold text-[#2E7D32] mt-2" data-id="element-27">
            HOY INCLUIDOS SIN COSTO ADICIONAL
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#FFF8F0] rounded-lg p-6 border-2 border-[#F5A623] hover:shadow-lg transition-shadow" data-id="element-29">
              <div className="flex items-start gap-4" data-id="element-30">
                <div className="bg-[#F5A623] text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-xl flex-shrink-0" data-id="element-31">
                  {bonus.number}
                </div>
                <div className="flex-1" data-id="element-32">
                  <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-33">
                    📋 BONO {bonus.number}
                  </h3>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-34">
                    {bonus.title}
                  </h4>
                  <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-35">
                    {bonus.description}
                  </p>
                  <div className="flex items-center gap-3" data-id="element-36">
                    <span className="text-gray-500 line-through" data-id="element-37">
                      Valor real: {bonus.value}
                    </span>
                    <span className="bg-[#2E7D32] text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-38">
                      ✅ GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}